// ─── Date & Period Helpers ────────────────────────────────────────────────────

/** Возвращает текущий месяц в формате "YYYY-MM" */
export function getCurrentMonth(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

/** Список последних 12 месяцев для выпадающего списка периодов */
export function getMonthsList(): { value: string; label: string }[] {
  const list: { value: string; label: string }[] = [];
  const now = new Date();
  for (let i = 0; i < 12; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const value = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
    const raw = d.toLocaleString('ru', { year: 'numeric', month: 'long' });
    list.push({ value, label: raw.charAt(0).toUpperCase() + raw.slice(1) });
  }
  return list;
}

// ─── Currency Formatters ──────────────────────────────────────────────────────

/** Форматирует сумму с единицами измерения (₸), сокращает крупные числа */
export function fmtSum(v: number): string {
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(2)} М ₸`;
  if (v >= 1_000) return `${(v / 1_000).toFixed(1)} К ₸`;
  return `${Math.round(v)} ₸`;
}

/** Краткая форма суммы (без ₸) для осей графиков */
export function fmtSumShort(v: number): string {
  if (v >= 1_000_000) return `${(v / 1_000_000).toFixed(1)}М`;
  if (v >= 1_000) return `${(v / 1_000).toFixed(0)}К`;
  return String(Math.round(v));
}
